/** @type {import("@mui/material").SxProps<Theme>} */
const styles = theme => ({
  modalRoot: {
    [theme.breakpoints.down('sm')]: {
      overflow: 'overlay',
    },
    '& .MuiBackdrop-root': {
      '@supports (-webkit-backdrop-filter: none) or (backdrop-filter: none)': {
        background: theme.palette.secondary.boxShadow,
        backdropFilter: 'blur(4.5px)',
      },
      '@supports not ((-webkit-backdrop-filter: none) or (backdrop-filter: none))': {
        background: theme.palette.primary.boxShadow3Medium,
      },
    },
  },
  channelContainer: {
    margin: 0,
    background: theme.palette.primary.header,
    position: 'sticky',
    top: 0,
    zIndex: 100,
    borderTopLeftRadius: '0.625rem',
    borderTopRightRadius: '0.625rem',
    [theme.breakpoints.down('sm')]: {
      height: '36px !important',
    },
  },
  modalContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'calc(100% - 23.3rem)',
    maxWidth: '991px',
    bgcolor: 'background.paper',
    borderRadius: '0.625rem',
    boxShadow: 24,
    background: theme.palette.secondary.contrastText,
    outline: 'none',

    '&::-webkit-scrollbar': {
      width: '0rem',
    },
    [theme.breakpoints.up('sm')]: {
      maxHeight: '90vh',
      overflowY: 'overlay',
    },
    [theme.breakpoints.down('sm')]: {
      position: 'unset',
      top: 'unset',
      left: 'unset',
      WebkitTransform: 'unset',
      transform: 'unset',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'unset',
      margin: '0.5rem auto 0',
      padding: 0,
      // height: '100%',
      width: 'calc(100vw - 1rem)',
      borderRadius: '0.625rem',
    },
  },
  modalContent: {
    marginTop: 0,
    width: '100% !important',
    marginLeft: '0rem',
  },
  subModalContent: {
    position: 'relative',
    overflowY: 'scroll',
    marginTop: '0rem !important',
    paddingTop: '0rem !important',

    [theme.breakpoints.up('sm')]: {
      height: '53rem',
      '&::-webkit-scrollbar': {
        width: '0.813rem',
      },
      '&::-webkit-scrollbar-track': {
        boxShadow: `inset 0 0 6px ${theme.palette.primary.boxShadow4}`,
        webkitBoxShadow: `inset 0 0 6px ${theme.palette.primary.boxShadow4}`,
        border: `1px solid ${theme.palette.secondary.borderGrey87}`,
        height: '100%',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.primary.disableCTA,
        border: '0.25rem solid transparent',
        borderRadius: '10rem',
        backgroundClip: 'padding-box',
      },
    },
  },
  title: {
    fontSize: '1.5rem',
    color: theme.palette.primary.textColor3,
    [theme.breakpoints.down('sm')]: { fontSize: '1.25rem' },
  },
  categoryName: {
    color: theme.palette.primary.textColor3,
  },
  categoryCount: {
    color: theme.palette.primary.textColor5,
  },
  channelListMain: {
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0.5rem !important',
    },
  },
  channelListRow: {
    pt: '10px',
    pb: '40px',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'unset',
      overflow: 'overlay',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    [theme.breakpoints.up('sm')]: {
      flexWrap: 'wrap',
    },
  },
  channelListRowElement: {
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0rem !important',
      marginLeft: '1rem',
      paddingTop: '0rem !important',
      height: '4.19rem',
      maxWidth: '4.19rem',
    },
  },
  channelIcon: {
    width: '3.75rem',
    height: '3.75rem',
    marginRight: '8px',
    borderRadius: '52rem',
    filter: `drop-shadow(2px 2px 2px ${theme.palette.primary.arrows})`,
    [theme.breakpoints.down('sm')]: {
      width: '4.19rem',
      height: '4.19rem',
    },
  },
});

export default styles;
